import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ProgressPayload } from '@/react-components/components/progress/types'

export const initialProgressState: ProgressPayload = {
  recommendations: [],
  flows: {},
}

const progressSlice = createSlice({
  name: 'progress',
  initialState: initialProgressState,
  reducers: {
    progressUpdated(_state, action: PayloadAction<ProgressPayload>) {
      return action.payload
    },
    progressReset() {
      return initialProgressState
    },
  },
})

export const { progressUpdated, progressReset } = progressSlice.actions

export const selectProgress = (state: { progress: ProgressPayload }) => state.progress

export default progressSlice.reducer
